import {UserType} from '../stores/authenticated';
import {find} from 'lodash-es';

export default class Authentication {
  parseJwt(jwt: string): { exp?: number } | null {
    let parse: { exp?: number } | null = null;
    if (jwt) {
      try {
        const base64Url = jwt.split('.')[1];
        const base64    = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        parse           = JSON.parse(decodeURIComponent(escape(window.atob(base64)))) as {
          exp?: number;
        };
      } catch {
        // 不正な JWT 形式
      }
    }

    return parse;
  }

  /** @deprecated JWT をクライアントで保持しない方針のため、互換のため残す */
  isValid(jwt: string): boolean {
    let invalid = false;
    const parse = this.parseJwt(jwt);

    if (parse?.exp !== undefined) {
      invalid = Date.now() < parse.exp * 1000;
    }

    return invalid;
  }

  /** httpOnly セッション: サーバーが返したアクセストークン有効期限（ms）で判定 */
  isSessionValid(accessTokenExpiresAt: number | null | undefined): boolean {
    return (
      typeof accessTokenExpiresAt === 'number' &&
      Number.isFinite(accessTokenExpiresAt) &&
      accessTokenExpiresAt > Date.now()
    );
  }

  isAdminValid(accessTokenExpiresAt: number | null | undefined, user: UserType | null): boolean {
    if (!user?.roles) {
      return false;
    }
    return (
      this.isSessionValid(accessTokenExpiresAt) &&
      (!!find(user.roles, { name: 'admin' }) || !!find(user.roles, { name: 'moderator' }))
    );
  }
}
